import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import dayjs from 'dayjs';
import { write, utils } from 'xlsx-js-style';

import { getDirectWorkerList } from '../../api/constlink';
import DirectWorkerListComponent from '../../components/work-records/DirectWorkerListComponent';
import saveAs from 'file-saver';
import { maskingRrn, s2ab } from '../../util/utils';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';
import DirectWorkerDownloadXlsxModal from '../../components/work-records/DirectWorkerDownloadXlsxModal';

interface DirectWorkerListContainerProps {
  enterpriseId: string;
  projectId: string;
}

function DirectWorkerListContainer({
  history,
  match,
}: RouteComponentProps<DirectWorkerListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [directWorkers, setDirectWorkers] = useState<any>();
  const [visible, setVisible] = useState(false);

  const currentProject = useSelector(
    (state: RootState) => state.projects.project.data,
  );
  const user = useSelector((state: RootState) => state.auth.auth.data);

  useEffect(() => {
    (async () => {
      const data = await getDirectWorkerList({ enterpriseId, projectId });
      console.log(data);
      setDirectWorkers(data);
    })();
  }, [enterpriseId, projectId]);

  const downloadFile = async (value: any) => {
    console.log(value);
    // console.log(dayjs('2025-01').startOf('month').format('YYYY-MM-DD'));
    // console.log(dayjs('2025-01').endOf('month').format('YYYY-MM-DD'));

    // for (let i = 0; i < data.length; i++) {
    //   const val: any[] = [];
    //   val.push(dayjs(data[i].billingDate).format('YYYY-MM-DD'));
    //   val.push(data[i].vendor.application.general.name);
    //   val.push(data[i].category);
    //   val.push(data[i].gongjong ?? '기타');
    //   val.push(
    //     data[i].vendor.type === VendorType.COMPANY ? '사업자' : '작업자',
    //   );
    //   val.push(
    //     data[i].vendor.application.general.jobLevel === undefined
    //       ? ''
    //       : data[i].vendor.application.general.jobLevel === '1'
    //       ? '기공'
    //       : '조공',
    //   );
    //   val.push(
    //     data[i].vendor.application.general.wageForm === undefined
    //       ? ''
    //       : vendorWorkerWageFormKorean[
    //           data[i].vendor.application.general
    //             .wageForm as VendorWorkerWageForm
    //         ],
    //   );
    //   val.push(invoiceStatusKorean[data[i].status as InvoiceType]);
    //   val.push(data[i].price - data[i].vat);
    //   val.push(data[i].vat);
    //   val.push(data[i].price);

    //   val.push(
    //     data[i].vendor.application.general.wageForm === undefined
    //       ? 0
    //       : data[i].vendor.application.general.wageForm ===
    //         VendorWorkerWageForm.FREELANCER
    //       ? Math.floor((data[i].price * 0.033) / 10) * 10
    //       : 0,
    //   );
    //   val.push(
    //     data[i].vendor.application.general.wageForm === undefined
    //       ? data[i].price
    //       : data[i].vendor.application.general.wageForm ===
    //         VendorWorkerWageForm.FREELANCER
    //       ? data[i].price - Math.floor((data[i].price * 0.033) / 10) * 10
    //       : data[i].price,
    //   );
    //   val.push(data[i].vendor.application.accountInfo.bankName);
    //   val.push(data[i].vendor.application.accountInfo.accountNumber);
    //   val.push(data[i].vendor.application.accountInfo.accountHolder);

    //   val.push(data[i].isCreditTransaction === true ? '예' : '아니오');
    //   val.push(data[i].submittedBy.name);
    //   val.push(data[i].project ? data[i].project.name : '');

    //   _data.push(val);
    // }
    var wb = utils.book_new();
    // const ws = await utils.json_to_sheet(_data);
    // [
    //   '청구일',
    //   '거래처명',
    //   '용도',
    //   '공정',
    //   // '거래처 유형',
    //   // '급여수준',
    //   // '급여방식',
    //   // '상태',
    //   // '공급가액',
    //   // '부가세액',
    //   // '합계금액',
    //   // '원천세',
    //   // '원천세 제외금액',
    //   // '거래처 은행명',
    //   // '거래처 계좌번호',
    //   // '거래처 예금주명',
    //   // '외상거래',
    //   // '제출자',
    //   // '현장명',
    // ].forEach((x, idx) => {
    //   const cellAdd = utils.encode_cell({ c: idx, r: 4 });
    //   ws[cellAdd].v = x;
    // });

    /*
    const origin = {
      directWorkerList: [
        {
          id: 0,
          name: '김민재',
          residentNumber: '9801254210811',
          gongjong: '전기공사',
          jigjong: '전기공',
          price: 300000,
          workDayList: [
            {
              workDay: '2025-02-27',
              numOfGongsu: 1,
            },
            {
              workDay: '2025-02-21',
              numOfGongsu: 2.0,
            },
            {
              workDay: '2025-02-11',
              numOfGongsu: 1.5,
            },
          ],
          totalNumOfGongsu: 2.5,
          address: '서울시 서초구 남부순환로 325길 17,신빌딩 305호',
          personalPhoneNumber: '01051629415',
        },
        {
          id: 1,
          name: '조규성',
          residentNumber: '7312153333333',
          gongjong: '목공사',
          jigjong: '목공',
          price: 400000,
          workDayList: [
            {
              workDay: '2025-02-11',
              numOfGongsu: 1.5,
            },
            {
              workDay: '2025-02-21',
              numOfGongsu: 2.0,
            },
          ],
          totalNumOfGongsu: 1.5,
          address: '서울시 서초구 남부순환로 325길 17,신빌딩 305호',
          personalPhoneNumber: '01051629415',
        },
      ],
    };
    */

    const test = [
      [
        { v: '회사명', t: 's', s: { font: { sz: 8 } } },
        [],
        [],
        { v: '공사명', t: 's', s: { font: { sz: 8 } } },
        [],
        [],
        [],
        [],
        [],
        [],
        { v: '기간', t: 's', s: { font: { sz: 8 } } },
        [],
        [],
        [],
        [],
      ],
      [
        { v: `${user?.myEnterprise.name}`, t: 's', s: { font: { sz: 8 } } },
        [],
        [],

        { v: `${currentProject!.name}`, t: 's', s: { font: { sz: 8 } } },
        [],
        [],
        [],
        [],
        [],
        [],
        {
          v: `${dayjs(value.selectedMonth)
            .startOf('month')
            .format('YYYY-MM-DD')} ~ ${dayjs(value.selectedMonth)
            .endOf('month')
            .format('YYYY-MM-DD')}`,
          t: 's',
          s: { font: { sz: 8 } },
        },
        [],
        [],
        [],
        [],
      ],
      [
        // '순번',
        { v: '순번', t: 's', s: { font: { sz: 8 } } },

        // '성명',
        { v: '성명', t: 's', s: { font: { sz: 8 } } },

        // '주민번호',
        { v: '주민번호', t: 's', s: { font: { sz: 8 } } },
        // '주소',
        { v: '주소', t: 's', s: { font: { sz: 8 } } },

        { v: '1', t: 's', s: { font: { sz: 8 } } },
        { v: '2', t: 's', s: { font: { sz: 8 } } },
        { v: '3', t: 's', s: { font: { sz: 8 } } },
        { v: '4', t: 's', s: { font: { sz: 8 } } },
        { v: '5', t: 's', s: { font: { sz: 8 } } },
        { v: '6', t: 's', s: { font: { sz: 8 } } },
        { v: '7', t: 's', s: { font: { sz: 8 } } },
        { v: '8', t: 's', s: { font: { sz: 8 } } },
        { v: '9', t: 's', s: { font: { sz: 8 } } },
        { v: '10', t: 's', s: { font: { sz: 8 } } },
        { v: '11', t: 's', s: { font: { sz: 8 } } },
        { v: '12', t: 's', s: { font: { sz: 8 } } },
        { v: '13', t: 's', s: { font: { sz: 8 } } },
        { v: '14', t: 's', s: { font: { sz: 8 } } },
        { v: '15', t: 's', s: { font: { sz: 8 } } },
        [],
        { v: '출역일수', t: 's', s: { font: { sz: 8 } } },
        { v: '단가', t: 's', s: { font: { sz: 8 } } },
        { v: '총액', t: 's', s: { font: { sz: 8 } } },
      ],
      [
        [],
        [],
        [],
        [],
        { v: '16', t: 's', s: { font: { sz: 8 } } },
        { v: '17', t: 's', s: { font: { sz: 8 } } },
        { v: '18', t: 's', s: { font: { sz: 8 } } },
        { v: '19', t: 's', s: { font: { sz: 8 } } },
        { v: '20', t: 's', s: { font: { sz: 8 } } },
        { v: '21', t: 's', s: { font: { sz: 8 } } },
        { v: '22', t: 's', s: { font: { sz: 8 } } },
        { v: '23', t: 's', s: { font: { sz: 8 } } },
        { v: '24', t: 's', s: { font: { sz: 8 } } },
        { v: '25', t: 's', s: { font: { sz: 8 } } },
        { v: '26', t: 's', s: { font: { sz: 8 } } },
        { v: '27', t: 's', s: { font: { sz: 8 } } },
        { v: '28', t: 's', s: { font: { sz: 8 } } },
        { v: '29', t: 's', s: { font: { sz: 8 } } },
        { v: '30', t: 's', s: { font: { sz: 8 } } },
        { v: '31', t: 's', s: { font: { sz: 8 } } },
      ],
    ];

    const mergeConfig = [
      { s: { c: 0, r: 0 }, e: { c: 2, r: 0 } },
      { s: { c: 3, r: 0 }, e: { c: 9, r: 0 } },
      { s: { c: 10, r: 0 }, e: { c: 14, r: 0 } },
      { s: { c: 0, r: 1 }, e: { c: 2, r: 1 } },
      { s: { c: 3, r: 1 }, e: { c: 9, r: 1 } },
      { s: { c: 10, r: 1 }, e: { c: 19, r: 1 } },

      { s: { c: 0, r: 2 }, e: { c: 0, r: 3 } },
      { s: { c: 1, r: 2 }, e: { c: 1, r: 3 } },
      { s: { c: 2, r: 2 }, e: { c: 2, r: 3 } },
      { s: { c: 3, r: 2 }, e: { c: 3, r: 3 } },
      { s: { c: 20, r: 2 }, e: { c: 20, r: 3 } },
      { s: { c: 21, r: 2 }, e: { c: 21, r: 3 } },
      { s: { c: 22, r: 2 }, e: { c: 22, r: 3 } },
    ];

    const wscols = [
      { wch: 4 },
      { wch: 6 },
      { wch: 8 },
      { wch: 10 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 2 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
    ];

    let index = 4;
    let num = 1;
    // for (const val of origin.directWorkerList) {
    for (const val of directWorkers.directWorkerList) {
      console.log(val);
      if (
        val.workDayList.filter((x: any) =>
          x.workDay.startsWith(value.selectedMonth),
        ).length === 0
      ) {
        continue;
      }
      const row: any = [
        { v: `${num++}`, t: 's', s: { font: { sz: 8 } } },
        { v: val.name, t: 's', s: { font: { sz: 8 } } },
        { v: maskingRrn(val.residentNumber), t: 's', s: { font: { sz: 8 } } },
        { v: val.address, t: 's', s: { font: { sz: 8 } } },
      ];
      const nextLine: any = [];
      for (const workDay of val.workDayList.filter((x: any) =>
        x.workDay.startsWith(value.selectedMonth),
      )) {
        const day = +workDay.workDay.split('-')[2];
        if (day > 15) {
          nextLine[day + 3 - 15] = {
            v: workDay.numOfGongsu,
            t: 'n',
            s: { font: { sz: 8 } },
          };
        } else {
          row[day + 3] = {
            v: workDay.numOfGongsu,
            t: 'n',
            s: { font: { sz: 8 } },
          };
        }
      }
      row[20] = {
        t: 'n',
        s: { font: { sz: 8 } },
        f: `SUM(E${index + 1}:T${index + 2})`,
      };
      row[21] = { v: val.price, t: 'n', s: { font: { sz: 8 } }, z: '#,##0' };
      row[22] = {
        t: 'n',
        s: { font: { sz: 8 } },
        z: '#,##0',
        f: `U${index + 1}*V${index + 1}`,
      };
      test.push(row);
      test.push([...nextLine]);
      mergeConfig.push({ s: { c: 0, r: index }, e: { c: 0, r: index + 1 } });
      mergeConfig.push({ s: { c: 1, r: index }, e: { c: 1, r: index + 1 } });
      mergeConfig.push({ s: { c: 2, r: index }, e: { c: 2, r: index + 1 } });
      mergeConfig.push({ s: { c: 3, r: index }, e: { c: 3, r: index + 1 } });
      mergeConfig.push({ s: { c: 20, r: index }, e: { c: 20, r: index + 1 } });
      mergeConfig.push({ s: { c: 21, r: index }, e: { c: 21, r: index + 1 } });
      mergeConfig.push({ s: { c: 22, r: index }, e: { c: 22, r: index + 1 } });
      index += 2;
    }

    console.log(test);

    var ws = utils.aoa_to_sheet(test);
    ws['!merges'] = mergeConfig;
    ws['!cols'] = wscols;

    utils.book_append_sheet(wb, ws, `${value.selectedMonth}`);
    const wbout = write(wb, { bookType: 'xlsx', type: 'binary' });
    saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      `출역현황_${value.selectedMonth}.xlsx`,
    );
  };

  return (
    <>
      {/* {loading && <Spin />}
      {error && <Alert message={`${error}`} type="error" showIcon closable />}
      {data && (
        <WorkRecordListComponent
          workRecords={data}
          moveToCreatePage={onCreate}
          moveToDetailPage={onDetail}
          onDelete={onDelete}
          onSelect={onSelect}
        />
      )} */}
      {directWorkers && (
        <DirectWorkerListComponent
          data={directWorkers}
          // downloadFile={downloadFile}
          openDirectWorkerDownloadXlsxModal={() => setVisible(true)}
        />
      )}
      {directWorkers && (
        <DirectWorkerDownloadXlsxModal
          visible={visible}
          monthList={directWorkers.monthList}
          onDownload={(value: any) => {
            downloadFile(value);
            setVisible(false);
          }}
          onCancel={() => setVisible(false)}
        />
      )}
    </>
  );
}

export default DirectWorkerListContainer;
